require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./configurations-cli-options.json") })
        }
      }, "path---configurations-cli-options");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---configurations-cli-options!./.cache/json/configurations-cli-options.json
// module id = 417
// module chunks = 231608221292675